import { Token } from "@istari-frontend/resource/model";
import { V3Models } from "@istari/istari-client";

export function toToken(token: V3Models.TokenDto): Token {
  return {
    sha: token.sha,
    salt: token.salt,
  };
}
